import { frontile } from '../plugin';

/**
 * This export provides the Frontile plugin in a format compatible with
 * Tailwind CSS v4's @plugin directive using default Frontile config, no overwrites.
 */
export default frontile();
